import en from './en.json';
import zh from './zh.json';
import cn from './cn.json';

export default {
  zh,
  en,
  cn,
};
